import { axios as request } from "../../request/http";

const interfaceUrl = {
  "api_shopInfoQueryList": "/shop/info/queryList", // 
  "api_shopAreaMainSpQueryList": "/shop/areaMainSp/queryList", //   查询主资金商/服务商区域
  "api_shopAreaMainSpUpdateArea": "/shop/areaMainSp/updateArea", //   设置区域主资金商/服务商
}

// initial state
const state = {
  shopInfoList: [],

  areaMainSp: {}
}

// getters
const getters = {
  getShopInfoQueryList: state => {
    return state.shopInfoList
  },
  getShopAreaMainSp: state => {
    return state.areaMainSp
  },
}

// actions
const actions = {
  getShopInfoQueryList: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_shopInfoQueryList,
      method: "POST",
      data: params,
    };
    return request(option).then(res => res.data).then(res => {
      if (res.code == 200) {
        commit('SHOPINFO_QUERY_LIST', res || {});
      } else {
        commit('SHOPINFO_QUERY_LIST', {});
      }
    }).catch(err => {
      commit('SHOPINFO_QUERY_LIST', {});
    })
  },
  getShopAreaMainSp: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_shopAreaMainSpQueryList,
      method: "GET",
      params,
    };
    return request(option).then(res => res.data).then(res => {
      if (res.code == 200) {
        commit('SHOP_AREA_MAIN_QUERY_LIST', res || {});
      } else {
        commit('SHOP_AREA_MAIN_QUERY_LIST', {});
      }
    }).catch(err => {
      commit('SHOP_AREA_MAIN_QUERY_LIST', {});
    })
  },
  shopAreaMainSpUpdateArea: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_shopAreaMainSpUpdateArea,
      method: "POST",
      data:params,
    };
    return request(option).then(res => res.data)
  },
}


// mutations
const mutations = {
  SHOPINFO_QUERY_LIST: (state, pageData) => {
    state.shopInfoList = pageData;
  },
  SHOP_AREA_MAIN_QUERY_LIST: (state, pageData) => {
    state.areaMainSp = pageData;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/shop.js